(function () {
  'use strict';

  if (window.LuxsterHeaderSearchController) {
    window.LuxsterHeaderSearchController.init();
    return;
  }

  var state = {
    panel: null,
    form: null,
    input: null,
    results: null,
    status: null,
    trigger: null,
    open: false,
    timer: null,
    request: null,
    revision: 0,
    options: [],
    active: -1,
    cachedTerm: null,
    cachedData: null
  };
  var mobileLayout = window.matchMedia('(max-width: 800px)');
  mobileLayout.addEventListener('change', function (event) {
    if (event.matches) close(false);
  });

  function focusWithoutScrolling(element) {
    if (!element || !element.isConnected) return;
    element.focus({ preventScroll: true });
  }

  function setExpanded(expanded) {
    document.querySelectorAll('[data-header-search-toggle]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', String(expanded));
    });
  }

  function cancelRequest() {
    window.clearTimeout(state.timer);
    state.timer = null;
    state.revision += 1;
    if (state.request) {
      state.request.abort();
      state.request = null;
    }
    if (state.results) state.results.setAttribute('aria-busy', 'false');
  }

  function setStatus(message) {
    if (!state.status) return;
    state.status.textContent = message || '';
    state.status.hidden = !message;
  }

  function message(name, fallback) {
    return state.panel.getAttribute('data-' + name) || fallback;
  }

  function clearActive() {
    state.options.forEach(function (option) {
      option.classList.remove('is-active');
      option.setAttribute('aria-selected', 'false');
    });
    state.active = -1;
    if (state.input) state.input.removeAttribute('aria-activedescendant');
  }

  function clearResults() {
    clearActive();
    state.options = [];
    state.results.replaceChildren();
    state.results.hidden = true;
    state.input.setAttribute('aria-expanded', 'false');
  }

  function close(restoreFocus) {
    cancelRequest();
    if (!state.panel) return;
    state.open = false;
    state.panel.hidden = true;
    clearActive();
    state.input.setAttribute('aria-expanded', 'false');
    setExpanded(false);
    if (restoreFocus) focusWithoutScrolling(state.trigger);
  }

  function searchURL(term, json) {
    var url = new URL(state.form.action || '/search', window.location.origin);
    url.search = '';
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', term);
    if (json) url.searchParams.set('view', 'json');
    return url;
  }

  function addOption(fragment, link, viewAll) {
    var option = document.createElement('li');
    option.id = 'LuxsterHeaderSearchOption-' + state.options.length;
    option.className = 'luxster-header-search__result';
    if (viewAll) option.classList.add('luxster-header-search__view-all');
    option.setAttribute('role', 'option');
    option.setAttribute('aria-selected', 'false');
    link.className = 'luxster-header-search__result-link';
    option.appendChild(link);
    state.options.push(option);
    fragment.appendChild(option);
  }

  function renderResults(data, term) {
    clearResults();
    var products = Array.isArray(data.results) ? data.results : [];
    var count = Math.max(0, Number(data.results_count) || products.length);
    var fragment = document.createDocumentFragment();

    products.forEach(function (product) {
      if (!product || !product.url) return;
      var url;
      try {
        url = new URL(product.url, window.location.origin);
      } catch (error) {
        return;
      }
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return;
      var link = document.createElement('a');
      link.href = url.href;
      if (product.thumbnail) {
        var image = document.createElement('img');
        image.className = 'luxster-header-search__result-image';
        image.src = product.thumbnail;
        image.alt = '';
        image.width = 48;
        image.height = 48;
        image.loading = 'lazy';
        link.appendChild(image);
      }
      var title = document.createElement('span');
      title.className = 'luxster-header-search__result-title';
      title.textContent = product.title || '';
      link.appendChild(title);
      addOption(fragment, link, false);
    });

    if (count > 0) {
      var allResults = document.createElement('a');
      allResults.href = searchURL(term, false).href;
      allResults.textContent = message('view-all', 'View all results ({count})').replace(/\{count\}/g, String(count));
      addOption(fragment, allResults, true);
    }

    state.results.appendChild(fragment);
    state.results.hidden = state.options.length === 0;
    state.input.setAttribute('aria-expanded', String(state.open && state.options.length > 0));
    setStatus(state.options.length ? '' : message('no-results', 'No results found.'));
  }

  function requestResults(term) {
    cancelRequest();
    if (!state.open || !term) return;
    var panel = state.panel;
    var revision = state.revision;
    var controller = new AbortController();
    state.request = controller;
    state.results.setAttribute('aria-busy', 'true');
    setStatus(message('loading', 'Searching…'));

    fetch(searchURL(term, true).href, {
      signal: controller.signal,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Search request failed: ' + response.status);
      return response.json();
    }).then(function (data) {
      if (revision !== state.revision || panel !== state.panel || !state.open || state.input.value.trim() !== term) return;
      state.cachedTerm = term;
      state.cachedData = data;
      renderResults(data, term);
    }).catch(function (error) {
      if (error.name === 'AbortError' || revision !== state.revision || panel !== state.panel || !state.open) return;
      clearResults();
      setStatus(message('error', 'Search is unavailable. Press Enter to view results.'));
    }).finally(function () {
      if (revision !== state.revision || panel !== state.panel) return;
      state.request = null;
      state.results.setAttribute('aria-busy', 'false');
    });
  }

  function updateSuggestions(immediate) {
    cancelRequest();
    clearResults();
    setStatus('');
    var term = state.input.value.trim();
    if (!state.open || !term) return;
    if (state.cachedTerm === term && state.cachedData) {
      renderResults(state.cachedData, term);
      return;
    }
    if (immediate) {
      requestResults(term);
    } else {
      state.timer = window.setTimeout(function () { requestResults(term); }, 180);
    }
  }

  function open(trigger) {
    if (mobileLayout.matches) return;
    state.trigger = trigger;
    state.open = true;
    state.panel.hidden = false;
    setExpanded(true);
    focusWithoutScrolling(state.input);
    updateSuggestions(true);
  }

  function init() {
    var panel = document.getElementById('LuxsterHeaderSearch');
    if (panel === state.panel) return !!panel;
    close(false);
    state.panel = null;
    if (!panel) return false;
    var form = panel.querySelector('[data-header-search-form]');
    var input = panel.querySelector('#LuxsterHeaderSearchInput');
    var results = panel.querySelector('#LuxsterHeaderSearchResults');
    if (!form || !input || !results) return false;
    state.panel = panel;
    state.form = form;
    state.input = input;
    state.results = results;
    state.status = panel.querySelector('[data-header-search-status]');
    state.options = [];
    state.active = -1;
    state.trigger = null;
    state.cachedTerm = null;
    state.cachedData = null;
    panel.hidden = true;
    clearResults();
    setStatus('');
    setExpanded(false);
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element) || !init()) return;
    var trigger = event.target.closest('[data-header-search-toggle]');
    if (trigger) {
      event.preventDefault();
      if (state.open) {
        state.trigger = trigger;
        close(true);
      } else {
        open(trigger);
      }
      return;
    }
    if (!state.open || !state.panel.contains(event.target)) return;
    if (event.target.closest('[data-header-search-close]')) {
      event.preventDefault();
      close(true);
    } else if (event.target.closest('#LuxsterHeaderSearchResults a')) {
      close(false);
    }
  });

  document.addEventListener('pointerdown', function (event) {
    if (!state.open || !(event.target instanceof Element)) return;
    if (!state.panel.contains(event.target) && !event.target.closest('[data-header-search-toggle]')) close(false);
  });

  document.addEventListener('input', function (event) {
    if (event.target === state.input && !event.isComposing) updateSuggestions(false);
  });

  document.addEventListener('compositionend', function (event) {
    if (event.target === state.input) updateSuggestions(false);
  });

  document.addEventListener('keydown', function (event) {
    if (!state.open || event.isComposing) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close(true);
      return;
    }
    if (event.target !== state.input || !state.options.length) return;
    if (event.key === 'Enter' && state.active >= 0) {
      event.preventDefault();
      state.options[state.active].querySelector('a').click();
      return;
    }
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    event.preventDefault();
    var next = event.key === 'ArrowDown' ? state.active + 1 : state.active < 0 ? state.options.length - 1 : state.active - 1;
    next = (next + state.options.length) % state.options.length;
    clearActive();
    state.active = next;
    var option = state.options[next];
    option.classList.add('is-active');
    option.setAttribute('aria-selected', 'true');
    state.input.setAttribute('aria-activedescendant', option.id);
    option.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });

  document.addEventListener('focusout', function () {
    if (!state.open) return;
    window.setTimeout(function () {
      if (!state.open) return;
      var focused = document.activeElement;
      if (!state.panel.contains(focused) && !(focused instanceof Element && focused.closest('[data-header-search-toggle]'))) close(false);
    }, 0);
  });

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    if (state.panel && event.target.contains(state.panel)) {
      close(false);
      state.panel = null;
    }
  });

  window.LuxsterHeaderSearchController = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
